import Page from 'src/components/page/page';
import useCollectiblesDetails from './collectibles-details.hook';
import { Box, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import CollectibleForm from './components/colletible-form';
import { paths } from 'src/routes/paths';
import { Icon } from '@iconify/react';

export default function CollectiblesDetails() {
  const {
    isEdit,
    isLoadingCollectibleDetails,
    methods,
    fields,
    renderedLocations,
    STATUS_LABEL,
    STATUS_OPTIONS,
    isSubmitting,
    collectionId,
    carouselRef,
    append,
    remove,
    removeAndEnsureEmpty,
    onSubmit,
    handleDropImagePreview,
    handleDropAdditionalImages,
    handleDropIconImage,
    navigate,
  } = useCollectiblesDetails();
  return (
    <Page title={isEdit ? 'Editar Colecionável' : 'Cadastrar Colecionável'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={
            <Stack direction="row" alignItems="center" spacing={1}>
              <Icon
                icon="weui:back-filled"
                width="18"
                height="22"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(paths.dashboard.collectionsDetails(collectionId!))}
              />
              <span>{isEdit ? 'Editar Colecionável' : 'Cadastrar Colecionável'}</span>
            </Stack>
          }
          links={[]}
        />
        {isLoadingCollectibleDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <Stack spacing={2}>
            <CollectibleForm
              methods={methods}
              onSubmit={onSubmit}
              handleDropImagePreview={handleDropImagePreview}
              handleDropAdditionalImages={handleDropAdditionalImages}
              fields={fields}
              append={append}
              remove={remove}
              removeAndEnsureEmpty={removeAndEnsureEmpty}
              handleDropIconImage={handleDropIconImage}
              renderedLocations={renderedLocations}
              STATUS_LABEL={STATUS_LABEL}
              STATUS_OPTIONS={STATUS_OPTIONS}
              isEdit={isEdit}
              isSubmitting={isSubmitting}
              carouselRef={carouselRef}
            />
          </Stack>
        )}
      </Container>
    </Page>
  );
}
